import * as geoUtils from '@/utilities/geospatial'
import { clone } from '@/utilities/geospatial'
import {
  POINT_FEATURE,
  LINE_FEATURE,
  POLYGON_FEATURE,
  FEATURE_COLLETION,
} from '@/data/Constants/Constants'
import { BASIC_STYLE } from '@/mapStyles/basic/style'
import { IMAGE_SOURCE_PROTOCOL } from '@/utilities/imageSourceProtocol'

export const getLayerIndex = (style, layerId) => {
  let layerIdx = null
  style?.layers?.forEach((layer, index) => {
    if (layer && layer.id === layerId) {
      layerIdx = index
    }
  })
  return layerIdx
}

export const getLayerType = (mapStyle, layerId) => {}

export const getLayerStyleLayerObject = (mapStyle, layerId) => {
  // layerId can be 'layername_1234' OR 'layer_name_1234_outline'
  // so we have to pop the last val after split, and if it is not a number
  // pop again
  const layerIdArray = layerId.split('_')
  let idNumber = layerIdArray.pop()
  // eslint-disable-next-line
  if (isNaN(idNumber)) idNumber = layerIdArray.pop()

  const layerArray = mapStyle?.layers?.filter(layer => {
    const targetLayerIdArray = layer?.id?.split('_')
    let targetLayerID = targetLayerIdArray?.pop()
    // eslint-disable-next-line
    if (isNaN(targetLayerID) && targetLayerIdArray?.length)
      targetLayerID = targetLayerIdArray.pop()
    // eslint-disable-next-line
    if (isNaN(targetLayerID)) return null
    if (idNumber === targetLayerID) {
      return geoUtils.clone(layer)
    }
    return null
  })

  if (layerArray?.length) return layerArray
  return null
}

export const getLayerObject = (mapStyle, layerId) => {
  const layerObject = mapStyle?.layers?.filter(layer => {
    if (layer?.id === layerId) {
      return geoUtils.clone(layer)
    }
  })
  return layerObject?.[0] || null
}

export const getLayerObjects = (hotLayers, style) => {
  return hotLayers.map(layer => {
    let hotLayer = getLayerObject(style, layer.hot)
    let coldLayer = getLayerObject(style, layer.cold)
    return { hot: hotLayer, cold: coldLayer }
  })
}

export const updateLayer = (mapStyle, layerId, newLayerObject) => {
  mapStyle.layers = mapStyle?.layers?.map((layer, index) => {
    if (layer?.id === layerId) return newLayerObject
    return layer
  })
  return mapStyle
}

export const getSource = (mapStyle, sourceId) => {
  const source = geoUtils.clone(mapStyle?.sources?.[sourceId])
  return source
}

export const addPointToVerticies = (hotSource, coordinates) => {
  const point = geoUtils.clone(POINT_FEATURE)
  point.geometry.coordinates = coordinates
  hotSource.data.features = [...hotSource?.data?.features, point]
}

export const addDataToDrawSource = (
  hotSource,
  verticies,
  coordinates,
  sourceId
) => {
  let source = geoUtils.clone(hotSource)
  if (sourceId === 'draw_line_hot') {
    if (!verticies?.data?.features) return source
    let verticieCount = verticies.data.features.length
    if (verticieCount === 1) {
      let coords = verticies.data.features.map(
        feature => feature?.geometry?.coordinates
      )
      const line = geoUtils.clone(LINE_FEATURE)
      line.geometry.coordinates.push(coords[0])
      source.data.features.push(line)
    }
    if (verticieCount > 1) {
      let coords = verticies.data.features.map(
        feature => feature?.geometry?.coordinates
      )
      const line = geoUtils.getLineString(coords)
      source.data.features[0] = line
    }
  }

  if (sourceId === 'draw_polygon_outline_hot') {
    if (!verticies?.data?.features) return source
    let verticieCount = verticies.data.features.length
    if (verticieCount === 1) {
      let coords = verticies.data.features.map(
        feature => feature?.geometry?.coordinates
      )
      const line = geoUtils.clone(LINE_FEATURE)
      line.geometry.coordinates.push(coords[0])
      source.data.features.push(line)
    }
    if (verticieCount > 1) {
      let coords = verticies.data.features.map(
        feature => feature?.geometry?.coordinates
      )
      let firstCoord = coords[0]
      coords.push(firstCoord)
      const line = geoUtils.getLineString(coords)
      source.data.features[0] = line
    }
  }

  if (sourceId === 'draw_polygon_hot') {
    let featureCount = source?.data?.features?.length
    if (featureCount === 0) {
      const polygon = geoUtils.clone(POLYGON_FEATURE)
      polygon.geometry.coordinates.push([coordinates])
      source.data.features.push(polygon)
    } else {
      source.data.features[0].geometry.coordinates[0].push(coordinates)
    }
  }

  if (sourceId === 'draw_text_hot') {
    const point = geoUtils.clone(POINT_FEATURE)
    point.geometry.coordinates = coordinates
    point.properties = {}
    point.properties.label = ''
    source.data.features = [...source?.data?.features, point]
  }

  if (sourceId === 'draw_find_vertex_buffer') {
    const polygon = geoUtils.clone(POLYGON_FEATURE)
    polygon.geometry.coordinates.push(coordinates)
    source.data.features = [polygon]
  }

  if (sourceId === 'draw_clicked_verticie') {
    const point = geoUtils.clone(POINT_FEATURE)
    point.geometry.coordinates = coordinates
    source.data.features = [point]
  }
  return source
}

export const createPointFeature = (coordinates, properties) => {
  const point = geoUtils.clone(POINT_FEATURE)
  point.geometry.coordinates = coordinates
  point.properties = properties
  return point
}

// TODO - add create polygwon and creat line functuions

export const addFeatureToSource = (originalSource, feature) => {
  const source = geoUtils.clone(originalSource)
  source.data.features.push(feature)
  return source
}

export const moveHotToCold = (
  hotSource,
  coldSource,
  coldSourceFeatureIndex = null
) => {
  // add to cold data
  if (!coldSource) return
  if (coldSourceFeatureIndex !== null) {
    hotSource.data.features[0].id = coldSourceFeatureIndex
    coldSource.data.features[coldSourceFeatureIndex] =
      hotSource.data.features[0]
  } else {
    hotSource?.data?.features?.forEach(feature => {
      feature.id = coldSource?.data?.features?.length
      coldSource.data.features.push(feature)
    })
  }
  hotSource.data.features = []
}

export const updateLastData = (mapSource, verticies, coordinates, sourceId) => {
  let source = geoUtils.clone(mapSource)
  // note: we recreate all features using verticies and adding coordinates
  if (sourceId === 'draw_line_hot') {
    if (verticies?.data?.features?.length > 0) {
      let coords = verticies.data.features.map(
        feature => feature?.geometry?.coordinates
      )
      const line = geoUtils.getLineString([...coords, ...[coordinates]])
      source.data.features[0] = line
    }
  }
  if (sourceId === 'draw_polygon_outline_hot') {
    if (verticies?.data?.features?.length > 0) {
      let coords = verticies.data.features.map(
        feature => feature?.geometry?.coordinates
      )
      coords = [...coords, ...[coordinates]]
      let firstCoord = coords[0]
      coords.push(firstCoord)
      const line = geoUtils.getLineString(coords)
      source.data.features[0] = line
    }
  }
  if (sourceId === 'draw_polygon_hot') {
    if (verticies?.data?.features?.length > 1) {
      let coords = verticies.data.features.map(
        feature => feature?.geometry?.coordinates
      )
      coords = [...coords, ...[coordinates]]
      let firstCoord = coords[0]
      coords.push(firstCoord)
      const poly = geoUtils.getPolygon([coords])
      source.data.features[0] = poly
    }
  }

  return source
}

export const replaceVerticie = (
  dataSource,
  type,
  vertices,
  newPoint,
  index,
  sourceId
) => {
  let source = geoUtils.clone(dataSource)
  let point = geoUtils.clone(newPoint)
  if (type === 'fill') {
    const first = 0
    const last = vertices.length - 1

    const firstCoords = vertices[first]?.geometry?.coordinates
    const lastCoords = vertices[last]?.geometry?.coordinates
    const isClosed =
      firstCoords &&
      lastCoords &&
      JSON.stringify(firstCoords) === JSON.stringify(lastCoords)

    if (isClosed) {
      if (index === first || index === last) {
        vertices[first] = point
        vertices[last] = point
      } else {
        vertices[index] = point
      }
    } else {
      // Open ring (deduped vertices). Only update the clicked vertex.
      vertices[index] = point
    }

    let coords = vertices.map(vert => vert?.geometry?.coordinates)
    // Ensure polygon ring is closed when building geometry
    if (coords.length > 0) {
      const cFirst = coords[0]
      const cLast = coords[coords.length - 1]
      if (JSON.stringify(cFirst) !== JSON.stringify(cLast)) {
        coords = [...coords, cFirst]
      }
    }
    const poly = geoUtils.getPolygon([coords])
    if (dataSource?.data?.features?.[0]?.properties) {
      poly.properties = dataSource.data.features[0].properties
    }
    source.data.features[0] = poly
  }
  if (type === 'line') {
    vertices[index] = point
    const coords = vertices.map(vert => vert?.geometry?.coordinates)
    const line = geoUtils.getLineString(coords)
    if (dataSource?.data?.features?.[0]?.properties) {
      line.properties = dataSource.data.features[0].properties
    }
    source.data.features[0] = line
  }
  if (type === 'circle') {
    vertices[index] = point
    if (dataSource?.data?.features?.[0]?.properties) {
      vertices[index].properties = dataSource.data.features[0].properties
      if (newPoint?.properties?.isSnapPoint) {
        vertices[index].properties['isSnapPoint'] = true
      }
    }
    source.data.features = vertices
  }
  return source
}

export const addVerticieBetweenCoords = (
  dataSource,
  feature,
  newCoords,
  coords1
) => {
  let source = geoUtils.clone(dataSource)
  if (feature?.geometry?.type === 'Polygon') {
    let coords = feature.geometry.coordinates[0]

    let updatedCoords = []
    let updated = false
    coords.forEach(coord => {
      updatedCoords.push(coord)
      if (coord.join(',') === coords1) {
        if (!updated) updatedCoords.push(newCoords)
        updated = true
      }
    })
    const poly = geoUtils.getPolygon([updatedCoords])
    source.data.features[0] = poly
  }
  return source
}

export const emptySource = source => {
  const fc = geoUtils.clone(FEATURE_COLLETION)
  source.data = fc
  return source
}

/**
 * Convert screen coordinates to [lng, lat] using MapLibre map instance
 * @param {number} x - Screen X coordinate
 * @param {number} y - Screen Y coordinate
 * @param {object} map - MapLibre map instance
 * @returns {[number, number] | undefined} [longitude, latitude]
 */
export const mouseClickToCoordinates = (x, y, map) => {
  if (!map || typeof map.unproject !== 'function') return
  const lngLat = map.unproject([x, y])
  return [lngLat.lng, lngLat.lat]
}

export const setLayerVisibility = (style, layerId, visible) => {
  let newStyle = geoUtils.clone(style)
  newStyle?.layers?.forEach(layer => {
    if (layer?.id === layerId) {
      if (!layer.layout || layer.layout.constructor !== Object) {
        layer.layout = {}
      }
      layer.layout.visibility = visible
    }
  })
  return newStyle
}

export const getVisibleTocLayers = (style, tocLayers) => {
  // find each layer in the toc that is visible and
  let visibleLayers = style?.layers
    ?.filter(
      styleLayer =>
        styleLayer?.layout && styleLayer?.layout?.visibility === 'visible'
    )
    .map(styleLayer => styleLayer.id)
  let visibleTocLayers = []
  const checkVisibility = layersArray => {
    let visible = false
    layersArray?.forEach(layerObj => {
      if (visibleLayers?.includes(layerObj?.layer?.id)) {
        visible = true
      }
    })
    return visible
  }
  const processTocLayer = tocLayer => {
    if (tocLayer?.layersArray) {
      const visible = checkVisibility(tocLayer.layersArray)
      if (visible) {
        visibleTocLayers.push(tocLayer?.toc?.id)
      }
    }
    if (tocLayer?.children) {
      tocLayer.children.items?.forEach(tocItem => {
        if (tocItem?.groupId) {
          processTocLayer(tocItem)
        } else {
          if (tocItem?.layersArray) {
            const visible = checkVisibility(tocItem.layersArray)
            if (visible) {
              visibleTocLayers.push(tocItem?.toc?.id)
            }
          }
        }
      })
    }
  }
  tocLayers?.forEach(tocLayer => {
    processTocLayer(tocLayer)
  })

  return visibleTocLayers
}

export const getVisibleImageryLayers = (style, imageryLayers) => {
  // find each layer in the toc that is visible and
  let visibleLayers = style?.layers
    ?.filter(
      styleLayer =>
        styleLayer?.layout && styleLayer?.layout?.visibility === 'visible'
    )
    .map(styleLayer => styleLayer.id)
  let visibleImageryLayers = []
  imageryLayers
    ?.filter(tocObject => tocObject?.layersArray)
    ?.forEach(tocObject => {
      return tocObject?.layersArray?.filter(layerObject => {
        if (visibleLayers?.includes(layerObject?.layer?.id)) {
          visibleImageryLayers.push(tocObject?.toc?.id)
        }
      })
    })
  return visibleImageryLayers
}

export const removeDuplicatesFromArray = arr => {
  let unique = arr
  unique = Array.from(new Set(arr.map(JSON.stringify)), JSON.parse)
  return unique
}

export const generateUID = () => {
  // Generate the UID from two parts
  // to ensure the random number provide enough bits.
  let firstPart = (Math.random() * 46656) | 0
  let secondPart = (Math.random() * 46656) | 0
  firstPart = ('000' + firstPart.toString(36)).slice(-3)
  secondPart = ('000' + secondPart.toString(36)).slice(-3)
  return firstPart + secondPart
}

const isPlainObject = value =>
  Object.prototype.toString.call(value) === '[object Object]'

export const addLayerToStyle = (style, layerObj, visible = 'none') => {
  if (!style || !Array.isArray(style.layers) || !layerObj) return style

  // get before layer
  let beforeLayer = layerObj?.beforeLayer
  // set beforeLayerIndex to the end of the layers array
  // if there is no before layer, the layer will be added to the top of the layer stack
  let beforeLayerIndex = style.layers.length
  if (beforeLayer) {
    const foundIndex = style.layers.findIndex(layer => layer?.id === beforeLayer)
    if (foundIndex >= 0) {
      beforeLayerIndex = foundIndex + 1
    }
  }
  Object.values(layerObj)
    .filter(layer => layer && typeof layer === 'object' && layer.id)
    .forEach(layer => {
      if (layer?.filter && layer?.filter?.constructor === Object) {
        // layers filters are being returned from api as object, per spec they must be array, delete
        delete layer.filter
      }
      if (!layer.layout || layer.layout.constructor !== Object) {
        layer.layout = {}
      }
      layer.layout.visibility = visible

      // Avoid duplicate IDs in style JSON; duplicate layer IDs can prevent style load.
      let removedBeforeInsertion = 0
      for (let index = style.layers.length - 1; index >= 0; index--) {
        if (style.layers[index]?.id === layer.id) {
          style.layers.splice(index, 1)
          if (index < beforeLayerIndex) {
            removedBeforeInsertion += 1
          }
        }
      }
      beforeLayerIndex -= removedBeforeInsertion
      if (beforeLayerIndex < 0) beforeLayerIndex = 0
      if (beforeLayerIndex > style.layers.length) {
        beforeLayerIndex = style.layers.length
      }

      style.layers.splice(beforeLayerIndex, 0, layer)
      beforeLayerIndex++
    })
  return style
}

export const removeLayersFromStyle = (style, layerId) => {
  let styleClone = clone(style)
  let layers = styleClone?.layers?.filter(layer => {
    return layer?.id?.substr(layer?.id?.lastIndexOf('_')) !== layerId
  })

  styleClone.layers = layers
  return styleClone
}

export const addSourceToStyle = (style, source, sourceIdFromLayer) => {
  if (!isPlainObject(source)) {
    console.warn('Skipping invalid source while building map style:', source)
    return style
  }
  if (!isPlainObject(style) || !isPlainObject(style.sources)) return style

  // get source id
  let id = source?.id
  // note: there is a bug in the profile layer tool that adds a source without an id
  // when this happens an undefined source is added to the style and will break the app
  // to prevent this from happening we send in the sourceIdFromLayer to use as the source id
  // TODO: find out what is casuing the source to sometimes not have an id
  if (!id) id = sourceIdFromLayer

  if (!id) {
    console.warn('Skipping source with no id while building map style:', source)
    return style
  }

  // Do not mutate the caller's source object.
  const sourceClone = clone(source)
  if (sourceClone && typeof sourceClone === 'object') {
    delete sourceClone.id

    // Repair image sources with null/invalid coordinates instead of dropping
    // them. MapLibre validates image-source coordinates on every style diff
    // (including camera events), so a single null value floods the console with
    // `number expected, null found` errors and can freeze interaction. We keep
    // the source (and therefore its layer) in the style so the layer remains
    // selectable and manageable — e.g. it can still be archived/deleted — but
    // swap in a tiny degenerate placeholder footprint so the corrupt image
    // doesn't render anywhere meaningful.
    if (sourceClone.type === 'image' && hasInvalidImageCoordinates(sourceClone)) {
      console.error(
        'Repairing image source with null/invalid coordinates (backend data issue):',
        id
      )
      sourceClone.coordinates = PLACEHOLDER_IMAGE_COORDINATES.map(pair => [
        ...pair,
      ])
    }

    style.sources[id] = sourceClone
  }

  return style
}

// A tiny, valid quad near [0, 0] used to replace corrupt image-source
// coordinates. Non-degenerate (so MapLibre's transform stays well-defined) but
// small enough (~11m) that the broken image is effectively invisible.
const PLACEHOLDER_IMAGE_COORDINATES = [
  [0, 0.0001],
  [0.0001, 0.0001],
  [0.0001, 0],
  [0, 0],
]

/**
 * True when an image source's `coordinates` are missing or contain any
 * non-numeric value. MapLibre requires exactly four `[lng, lat]` pairs of
 * finite numbers.
 */
const hasInvalidImageCoordinates = source => {
  const coords = source?.coordinates
  if (!Array.isArray(coords) || coords.length !== 4) return true
  return coords.some(
    pair =>
      !Array.isArray(pair) ||
      pair.length < 2 ||
      !Number.isFinite(pair[0]) ||
      !Number.isFinite(pair[1])
  )
}

/**
 * Remove any layer whose `source` is not present in `style.sources`. MapLibre
 * requires every non-background layer to reference an existing source; a
 * dangling reference (e.g. a source we intentionally skipped because its data
 * was corrupt, such as an image source with null coordinates) makes `setStyle`
 * throw "source not found" and aborts the entire style update. Background
 * layers have no source and are always kept.
 * @note Mutates `style.layers`; returns the same `style` reference.
 */
export const pruneLayersWithMissingSources = style => {
  if (
    !isPlainObject(style) ||
    !Array.isArray(style.layers) ||
    !isPlainObject(style.sources)
  ) {
    return style
  }
  style.layers = style.layers.filter(layer => {
    // Background layers (and any layer without a source) are always valid.
    if (!layer || layer.source == null) return true
    if (style.sources[layer.source] != null) return true
    console.warn(
      'Removing layer referencing a missing source from map style:',
      layer.id,
      layer.source
    )
    return false
  })
  return style
}

/**
 * Set or replace the cache-busting `dt` query param without dropping other keys
 * (tile URLs sometimes carry signatures or auth pairs after dt).
 *
 * @param {string} tileUrl
 * @param {number} timestamp
 * @returns {string}
 */
const bustTileUrlDtParam = (tileUrl, timestamp) => {
  if (typeof tileUrl !== 'string') return tileUrl
  const tsStr = String(timestamp)
  const qsIndex = tileUrl.indexOf('?')
  if (qsIndex === -1) {
    const hashIdxNoQs = tileUrl.indexOf('#')
    if (hashIdxNoQs === -1) {
      return `${tileUrl}?dt=${tsStr}`
    }
    return `${tileUrl.slice(0, hashIdxNoQs)}?dt=${tsStr}${tileUrl.slice(hashIdxNoQs)}`
  }
  const base = tileUrl.slice(0, qsIndex)
  const rest = tileUrl.slice(qsIndex + 1)
  const hashIndex = rest.indexOf('#')
  const queryOnly = hashIndex === -1 ? rest : rest.slice(0, hashIndex)
  const hashSuffix = hashIndex === -1 ? '' : rest.slice(hashIndex)
  /** @returns {string} */
  const withoutDtThenSet = queryString => {
    const kept = queryString
      .split('&')
      .filter(pair => {
        const eqIdx = pair.indexOf('=')
        const key =
          eqIdx === -1 ? pair.trimStart() : pair.slice(0, eqIdx).trimStart()
        return key !== 'dt'
      })
      .filter(Boolean)
    kept.push(`dt=${tsStr}`)
    return kept.join('&')
  }
  try {
    const params = new URLSearchParams(queryOnly)
    params.set('dt', tsStr)
    const rebuilt = params.toString()
    return rebuilt
      ? `${base}?${rebuilt}${hashSuffix}`
      : `${base}?dt=${tsStr}${hashSuffix}`
  } catch {
    const rebuiltFallback = queryOnly
      ? withoutDtThenSet(queryOnly)
      : `dt=${tsStr}`
    return `${base}?${rebuiltFallback}${hashSuffix}`
  }
}

export const addTocLayersToMapStyle2 = (
  mapStyle,
  oldStyle,
  dataConfig,
  visibleLayers = []
) => {
  const addLayers = (layersArray, style) => {
    layersArray?.forEach(layerObj => {
      try {
        if (!layerObj?.layer) {
          console.warn('Skipping layer with missing layer definition:', layerObj)
          return
        }
        if (oldStyle) {
          // if old style get old layer and use it to define props for layer in new style
          // this is done to preserve layer props like visibiltiy, filter, and metadata
          let oldStyleLayer = oldStyle?.layers?.filter(
            oldLayer => oldLayer?.id === layerObj?.layer?.id
          )

          let layout = oldStyleLayer?.[0]?.layout
          let paint = oldStyleLayer?.[0]?.paint
          let filter = oldStyleLayer?.[0]?.filter || []
          let metadata = oldStyleLayer?.[0]?.metadata

          layerObj.layer.layout = layout
          layerObj.layer.paint = paint
          layerObj.layer.filter = filter
          layerObj.layer.metadata = metadata

          if (layerObj?.layer?.filter && !layerObj?.layer?.filter?.length) {
            delete layerObj.layer.filter
          }

          style = addLayerToStyle(style, layerObj, layout?.visibility)
        } else {
          // Use the layer's own default visibility as the baseline so that
          // configs that explicitly set 'visible' are respected.
          // Falls back to 'none' so existing layers with no visibility set remain hidden.
          let visible =
            layerObj?.layer?.layout?.visibility === 'visible' ? 'visible' : 'none'

          if (visibleLayers && visibleLayers.includes(layerObj?.layer?.id)) {
            visible = 'visible'
          }

          if (layerObj?.layer?.filter && !layerObj?.layer?.filter?.length) {
            delete layerObj.layer.filter
          }
          style = addLayerToStyle(style, layerObj, visible)
        }
      } catch (err) {
        console.warn(
          'Failed to add layer to map style, skipping:',
          layerObj?.layer?.id ?? layerObj,
          err
        )
      }
    })

    return style
  }

  const addSources = (sourcesArray, style, sourceId) => {
    sourcesArray?.forEach(source => {
      const sourceToAdd =
        source && typeof source === 'object'
          ? {
              ...source,
              tiles: Array.isArray(source.tiles) ? [...source.tiles] : source.tiles,
            }
          : source

      if (Array.isArray(sourceToAdd?.tiles)) {
        // Bust tiles.myassetmap.com cache without dropping sibling query keys
        // (`bustTileUrlDtParam`).
        sourceToAdd.tiles = sourceToAdd.tiles.map(tileUrl => {
          if (typeof tileUrl !== 'string') return tileUrl
          return tileUrl.includes(`https://tiles.myassetmap.com`)
            ? bustTileUrlDtParam(tileUrl, Date.now())
            : tileUrl
        })
      }

      if (sourceToAdd?.type === 'image' && sourceToAdd?.url) {
        sourceToAdd.url = `${IMAGE_SOURCE_PROTOCOL}://${sourceToAdd.url}`
      }

      style = addSourceToStyle(style, sourceToAdd, sourceId)
    })
    return style
  }

  const processConfigObj = config => {
    // add groups
    if (config?.children) {
      // Note: reversing the tocLayers is needed to maintain proper layer order
      config.children.items?.reverse()?.forEach(item => {
        try {
          if (item?.children) {
            processConfigObj(item)
          } else {
            if (item?.layersArray) {
              newMapStyle = addLayers(item.layersArray, newMapStyle)
            }
            if (item?.sourcesArray) {
              const sourceId = item?.layersArray?.[0]?.layer?.source
              newMapStyle = addSources(item.sourcesArray, newMapStyle, sourceId)
            }
          }
        } catch (err) {
          console.warn(
            'Failed to process layer group item, skipping:',
            item?.layersArray?.[0]?.layer?.id ?? item,
            err
          )
        }
      })
    }
    // add layers
    if (config?.layersArray) {
      newMapStyle = addLayers(config.layersArray, newMapStyle)
    }
    // add sources
    if (config?.sourcesArray) {
      if (config?.layersArray?.[0]) {
        const sourceId = config.layersArray[0]?.layer?.source
        newMapStyle = addSources(config.sourcesArray, newMapStyle, sourceId)
      } else console.warn('Invalid Layer (Source) Identified: ', config)
    }
  }

  let newMapStyle = mapStyle
  // Note: reversing the tocLayers is needed to maintain proper layer order
  dataConfig['tocLayers']?.reverse()?.forEach(config => {
    try {
      processConfigObj(config)
    } catch (err) {
      console.warn(
        'Failed to process layer config, skipping:',
        config?.layersArray?.[0]?.layer?.id ?? config,
        err
      )
    }
  })

  return newMapStyle
}

export const resetMapStyle = dataConfig => {
  // this function will replace the current mapStyle with a new mapStyle starting from BASIC_STYLE
  // this is used when the map is switched with the mapSelector in MapSelector.js
  const dConfig = clone(dataConfig)
  let newMapStyle = clone(BASIC_STYLE)
  const visibleLayers = []
  newMapStyle = addTocLayersToMapStyle2(
    newMapStyle,
    null,
    dConfig,
    visibleLayers
  )
  dConfig?.auxiliaryLayers?.forEach(config => {
    try {
      if (config?.layersArray) {
        config.layersArray.forEach(layerObj => {
          try {
            const visible = layerObj?.layer?.layout?.visibility
            newMapStyle = addLayerToStyle(newMapStyle, layerObj, visible)
          } catch (err) {
            console.warn(
              'Failed to add auxiliary layer, skipping:',
              layerObj?.layer?.id ?? layerObj,
              err
            )
          }
        })
      }
      // add sources
      if (config?.sourcesArray) {
        config.sourcesArray.forEach(source => {
          newMapStyle = addSourceToStyle(
            newMapStyle,
            source,
            config?.layersArray?.[0]?.layer?.source
          )
        })
      }
    } catch (err) {
      console.warn(
        'Failed to process auxiliary layer config, skipping:',
        config?.layersArray?.[0]?.layer?.id ?? config,
        err
      )
    }
  })
  dConfig?.imageryLayers?.forEach(config => {
    try {
      if (config?.layersArray) {
        config.layersArray.forEach(layerObj => {
          try {
            newMapStyle = addLayerToStyle(newMapStyle, layerObj)
          } catch (err) {
            console.warn(
              'Failed to add imagery layer, skipping:',
              layerObj?.layer?.id ?? layerObj,
              err
            )
          }
        })
      }
      // add sources
      if (config?.sourcesArray) {
        config.sourcesArray.forEach(source => {
          newMapStyle = addSourceToStyle(newMapStyle, source)
        })
      }
    } catch (err) {
      console.warn(
        'Failed to process imagery layer config, skipping:',
        config?.layersArray?.[0]?.layer?.id ?? config,
        err
      )
    }
  })
  return pruneLayersWithMissingSources(newMapStyle)
}

/**
 * @typedef {Object} Style
 * @property {Array<Object>} layers - The layers in the map style
 * @property {Object} sources - The sources in the map style
 */
/**
 * Bust tile cache for a given layer id by appending a timestamp param to its source tile URLs
 * @note Mutates the provided style object; returns the same reference.
 * @param {Style} style - The map style object
 * @param {string} layerId - The id of the layer to bust the tile cache for
 * @returns {Style} The updated map style object
 */
export const bustSourceTilesByLayerId = (style, layerId) => {
  if (
    !isPlainObject(style) ||
    !Array.isArray(style.layers) ||
    !isPlainObject(style.sources) ||
    !layerId
  ) {
    return style
  }
  const timestamp = Date.now()

  const sourceIds = style.layers
    .filter(layer => layer && layer.id === layerId)
    .map(layer => layer.source)
    .filter(Boolean)

  if (!sourceIds.length) return style

  sourceIds.forEach(id => {
    const src = style.sources[id]
    if (!isPlainObject(src) || !Array.isArray(src.tiles)) return

    src.tiles = src.tiles.map(tileUrl =>
      bustTileUrlDtParam(tileUrl, timestamp)
    )
  })

  return style
}

/**
 * Reference-preserving variant of {@link bustSourceTilesByLayerId}.
 *
 * Where the legacy helper expects a deep-cloned style and mutates the whole
 * thing, this helper produces a shallow-cloned style where ONLY the affected
 * source object is rebuilt. Every other layer and source keeps its original
 * reference.
 *
 * Why this matters: when the returned style is dispatched to Redux and then
 * picked up by `react-maplibre` → `map.setStyle(newStyle, {diff: true})`,
 * MapLibre's style diff compares each layer/source. With reference-equal
 * objects everywhere except the one rebuilt source, the diff bails out fast
 * on everything else and produces a single `setTiles`-equivalent operation
 * instead of the avalanche of `setFilter` / `setLayoutProperty` / etc. that
 * a fully deep-cloned style produces. In practice this cuts the post-save
 * "can't select any feature" window from ~5s to a tile-fetch-bound flicker
 * on the affected source alone.
 *
 * If the layer / its source isn't tile-backed, returns the input unchanged
 * (same reference) so callers can chain multiple busts and check
 * `result !== input` to know whether to dispatch.
 *
 * @param {Style} style - The map style object (NOT mutated).
 * @param {string} layerId - Layer whose source's tile URLs should be busted.
 * @returns {Style} A shallow-cloned style with the affected source rebuilt,
 *   or the same reference if nothing was applicable.
 */
export const bustLayerTilesSurgical = (style, layerId) => {
  if (
    !isPlainObject(style) ||
    !Array.isArray(style.layers) ||
    !isPlainObject(style.sources) ||
    !layerId
  ) {
    return style
  }

  const layer = style.layers.find(
    mapStyleLayer => mapStyleLayer && mapStyleLayer.id === layerId
  )
  if (!layer || !layer.source) return style

  const sourceId = layer.source
  const src = style.sources[sourceId]
  if (!isPlainObject(src) || !Array.isArray(src.tiles)) return style

  const timestamp = Date.now()
  const tiles = src.tiles
  let anyTileChanged = false
  const nextTiles = tiles.map(tileUrl => {
    const busted = bustTileUrlDtParam(tileUrl, timestamp)
    if (busted !== tileUrl) anyTileChanged = true
    return busted
  })

  if (!anyTileChanged) return style

  return {
    ...style,
    sources: {
      ...style.sources,
      [sourceId]: {
        ...src,
        tiles: nextTiles,
      },
    },
  }
}
